// Helpers d'URL et de marque, centralisés pour le déploiement sous sous-chemin
// (ex. /dokimmo derrière le reverse-proxy CMSD) et la réutilisation multi-domaine.
//
// Mécanisme : Vite expose `import.meta.env.BASE_URL` (dérivé de `base` dans
// vite.config.ts). En dev/préprod, `base` vaut '/' → BASE_URL = '/'. En prod
// sous-chemin, le build passe `VITE_BASE=/dokimmo/` → BASE_URL = '/dokimmo/'.
// Tout est donc NEUTRE par défaut : sans VITE_BASE, comportement racine inchangé.

// Préfixe de base SANS slash final : '' en dev, '/dokimmo' en prod sous-chemin.
export const BASE = import.meta.env.BASE_URL.replace(/\/$/, '');

// Redirection vers la page de login en respectant le préfixe de déploiement.
// Remplace les `window.location.href = '/login'` bruts (qui bypassent le router
// et tomberaient sur la racine du reverse-proxy hôte, pas sur l'app).
export function redirectToLogin(): void {
  window.location.href = `${BASE}/login`;
}

// Marque affichée (titre d'onglet, alt des logos). Défaut « Dokimo » ;
// surchargeable au build via VITE_APP_BRAND (ex. « DokImmo » pour CMSD).
export const BRAND = import.meta.env.VITE_APP_BRAND || 'Dokimo';

// URL du logo, préfixée par BASE et avec un nom de fichier configurable.
// Défaut `Dokimo.png` (commité dans public/) ; surchargeable via VITE_APP_LOGO.
// On normalise un éventuel slash initial du nom (VITE_APP_LOGO='/x.png' comme
// 'x.png') pour éviter un double-slash sous le préfixe. Réutilise BASE (source
// unique du préfixe) plutôt que de re-dériver BASE_URL.
const LOGO_FILE = (import.meta.env.VITE_APP_LOGO || 'Dokimo.png').replace(/^\//, '');
export const LOGO = `${BASE}/${LOGO_FILE}`;

// URL de l'icône d'onglet (favicon). DISTINCTE de LOGO : le logo de marque
// (`Dokimo.png`, large ~850×225) est fait pour l'en-tête ; le favicon a besoin
// d'une image ~carrée sinon il est écrasé horizontalement dans l'onglet.
// Défaut `logo.png` (225×221, commité dans public/) ; surchargeable via
// VITE_APP_ICON pour le branding par domaine.
const ICON_FILE = (import.meta.env.VITE_APP_ICON || 'logo.png').replace(/^\//, '');
export const ICON = `${BASE}/${ICON_FILE}`;
